module.exports = __webpack_public_path__ + "img/music1.04d6f41e.gif";